import * as yup from 'yup';

export const validationSchema = yup.object({
  outcomeDate: yup.date().required('Outcome date is required.'),
  outcomeId: yup.string().required('Review outcome is required.'),
});
